import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 12157 17444"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#2b2a29}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1970278500912">
        <path
          d="M220 6242 5413 302c352-403 979-403 1331 0l5192 5940c500 572 94 1466-665 1466H886c-759 0-1165-894-666-1466zM10230 9909c0 345-280 625-625 625s-625-280-625-625 280-625 625-625 625 280 625 625zM7879 9909c0 345-280 625-625 625s-625-280-625-625 280-625 625-625 625 280 625 625z"
          className="fil0"
        />
        <circle
          r={3749}
          className="fil0"
          transform="matrix(0 -.16656 -.16656 0 4902.93 9908.88)"
        />
        <path
          d="M3177 9909c0 345-280 625-625 625s-625-280-625-625 280-625 625-625 625 280 625 625zM10230 12212c0 345-280 625-625 625s-625-280-625-625 280-625 625-625 625 280 625 625zM7879 12212c0 345-280 625-625 625s-625-280-625-625 280-625 625-625 625 280 625 625zM5528 12212c0 345-280 625-625 625s-625-280-625-625 280-625 625-625 625 280 625 625zM3177 12212c0 345-280 625-625 625s-625-280-625-625 280-625 625-625 625 280 625 625zM7879 14515c0 346-280 625-625 625s-625-279-625-625c0-345 280-624 625-624s625 280 625 624zM5528 14515c0 346-280 625-625 625s-625-279-625-625c0-345 280-624 625-624s625 280 625 624zM7879 16819c0 345-280 625-625 625s-625-280-625-625 280-625 625-625 625 280 625 625z"
          className="fil0"
        />
        <circle
          r={3749}
          className="fil0"
          transform="matrix(0 -.16656 -.16656 0 4902.93 16818.9)"
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
